import { ForcedSubject, MongoAbility, RawRuleOf } from '@casl/ability'
import { baseApi } from '@shared/api'

export const actions = [
  'all',
  'disabled',
  'view',
  'create',
  'read',
  'update',
  'delete',
  'approve',
  'sign',
  'invite',
] as const

export const subjects = [
  'AsanSigner',
  'ItsMeButton',
  'BusinessCardLimit',
  'BusinessCardBlock',
  'NewIcon',
  'OrderMenuItem',
  'SalaryCardMenuItem',
  'BusinessCardOrderMenuItem',
  'all',
] as const

export type AppAbilities = [
  (typeof actions)[number],
  (
    | (typeof subjects)[number]
    | ForcedSubject<Exclude<(typeof subjects)[number], 'all'>>
  )
]

export type Permission = RawRuleOf<MongoAbility<AppAbilities>>

export interface PermissionRules {
  global: Permission[]
  modules: Record<string, Record<string, Permission[]>>
}

export interface SessionInfoType {
  permission: PermissionRules
  userName: string
  userLongName: string
  customerNo: string
  phoneNumber: string
  authType: string
  role: string
  asanRole: any
  userId: any
  channel: string
  authToken: string
  locale: string
  deviceId: any
  refreshToken: any
  userCif: any
  userFin: string
  isTOTPEnabled: boolean
  viewable: boolean
}

export const sessionInfoApi = baseApi.injectEndpoints({
  endpoints(builder) {
    return {
      fetchSessionInfoWithPermissions: builder.query<SessionInfoType, void>({
        query: () => ({
          url: '/ib/signing/session/info',
          method: 'POST',
          skipGlobalError: true,
        }),
      }),
    }
  },
})

export const {
  useFetchSessionInfoWithPermissionsQuery,
  useLazyFetchSessionInfoWithPermissionsQuery,
} = sessionInfoApi
